const langList = ['zh-hans', 'en']

export function setLang(val) {
  let lang = langList.includes(val) ? val : getLang()
  localStorage.setItem('i18n_lang', lang)
  return lang
}

export function getLang() {
  return localStorage.getItem('i18n_lang') || 'zh-hans'
}
